// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"b474680d","541":"b1c85206"}[chunkId] + ".chunk.css";
};